import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from './ui/use-toast';
import { fetchWithRetry } from '../utils/tourUtils';
import { API_BASE_URL, LOGO_PATH, MAIN_IMAGE_PATH } from '../config';
import { FUNCTION_NAMES } from '../constants';
import { useUser } from './UserContext';

const Login = () => {
  const { setSelectedUser, setSelectedUserPermissions } = useUser();
  const [form, setForm] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!form.email || !/^\S+@\S+\.\S+$/.test(form.email)) {
      toast({ title: 'Invalid email format' });
      return false;
    }
    if (!form.password || form.password.length < 6) {
      toast({ title: 'Password must be at least 6 characters' });
      return false;
    }
    return true;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await fetchWithRetry({
        url: `${API_BASE_URL}/auth/login`,
        throwError: true,
        data: {
          payload: {
            email: form.email.toString().trim(),
            password: form.password.toString().trim(),
          },
        },
        label: 'login',
        retries: 1,
      });

      const user = response.user;
      const token = response.token;
      if (!user || !user.isActive) {
        throw new Error('Your account is not active yet');
      }

      setSelectedUser(user.id);
      setSelectedUserPermissions(user.permissions || []);
      localStorage.setItem('authToken', token);
      localStorage.setItem('selectedUser', user.id);
      localStorage.setItem('selectedUserEmail', user.email);
      localStorage.setItem('selectedUserPermissions', JSON.stringify(user.permissions || []));
      toast({ title: `Welcome ${user.firstNameEn}` });
      navigate('/');
    } catch (err) {
      toast({ title: 'Login failed', description: err.message });
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      {/* Left image side */}
      <div className="hidden md:flex w-full md:w-2/3 max-h-screen">
        <img
          src={MAIN_IMAGE_PATH}
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Right login form */}
      <div className="w-full md:w-1/3 flex flex-col justify-center px-8 py-12 bg-white">
        <div className="flex flex-col items-center space-y-6">
          <img src={LOGO_PATH} alt="Logo" className="w-32 h-32 object-contain" />
          <h2 className="text-xl font-semibold text-center">כניסה למערכת</h2>

          <form className="space-y-4 w-full max-w-sm" onSubmit={handleSubmit}>
            <Input
              name="email"
              placeholder="שם משתמש"
              value={form.email}
              onChange={handleChange}
              required
              dir="rtl"
            />
            <Input
              name="password"
              placeholder="סיסמא"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              dir="rtl"
            />
            <Button type="submit" className="w-full">
              כניסה
            </Button>
            <p className="text-sm text-center text-blue-600 mt-2 cursor-pointer hover:underline">
              שכחת סיסמא?
            </p>
          </form>

          <p className="text-xs text-gray-400 mt-4">Developed by Agamim Gross L.T.D</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
